export const iconFontAwesomeAlphabetH = (
	<i className="fa-solid fa-h"></i>
);
